import React from "react";
import styled, { css } from "styled-components";

import { UseOnClickArgs, useOnClickProps } from "../hooks/useOnClickProps";

import { HexAnchorButton, HexAnchorButtonProps } from "./HexButton";

type HexLinkProps = Pick<UseOnClickArgs, "to" | "target" | "replace">;

export const HexLinkButton = ({
  children,
  onClick,
  ref,
  replace,
  target,
  to,
  ...otherProps
}: HexAnchorButtonProps &
  HexLinkProps & { ref?: React.Ref<HTMLAnchorElement> }) => {
  const linkProps = useOnClickProps({
    replace,
    onClick,
    target,
    to,
  });
  return (
    <HexAnchorButton {...otherProps} {...linkProps} ref={ref}>
      {children}
    </HexAnchorButton>
  );
};

export const ResetAnchor = styled.a<{ $muted?: boolean; $ellipsize?: boolean }>`
  ${({ theme }) => theme.resets.a}
  text-decoration: none;
  && {
    color: ${({ $muted, theme }) =>
      $muted ? theme.fontColor.MUTED : "inherit"};
  }

  /*
  This is required to show underlines in reset anchors in toasts which set their own overrides
  3 &s for specificity
  */
  &&&:hover {
    text-decoration: underline;
  }

  ${({ $ellipsize }) =>
    $ellipsize &&
    css`
      display: inline-block;
      text-overflow: ellipsis;
      white-space: nowrap;
      overflow: hidden;
    `}
`;

export const HexCleanLink = ({
  children,
  className,
  ellipsize,
  muted,
  onClick,
  onContextMenu,
  ref,
  replace,
  target,
  to,
}: HexLinkProps & {
  children?: React.ReactNode;
  className?: string;
  ellipsize?: boolean;
  muted?: boolean;
  onContextMenu?: React.MouseEventHandler<HTMLAnchorElement>;
  onClick?: React.MouseEventHandler<HTMLAnchorElement | HTMLElement>;
  ref?: React.Ref<HTMLAnchorElement>;
}) => {
  const linkProps = useOnClickProps({
    replace,
    target,
    to,
    onClick,
  });
  return (
    <ResetAnchor
      className={className}
      {...linkProps}
      ref={ref}
      $ellipsize={ellipsize}
      $muted={muted}
      onContextMenu={onContextMenu}
    >
      {children}
    </ResetAnchor>
  );
};
